import React from "react";
import SimpleCircle from "./simple-circle";
import { Circles, Title } from "./three-simple-circles.styled";
import { ThreeSimpleCirclesSliceFragment } from "../../types/graphql";
import { SliceComponentProps } from "@prismicio/react";
import { Slice } from "@prismicio/types";
import { IPageContext } from "../../types/types";
import { SharedSliceType } from "../shared-slice/shared-slice";

export type IThreeSimpleCirclesProps = Slice<
  SharedSliceType,
  ThreeSimpleCirclesSliceFragment["primary"]
> & { type: SharedSliceType };

const ThreeSimplecircles = ({
  slice,
  context,
}: SliceComponentProps<IThreeSimpleCirclesProps, IPageContext>) => {
  var circles = slice.primary;
  return circles ? (
    <section className="slice-section">
      <div className="container">
        {circles.title && <Title>{circles.title}</Title>}
        <Circles>
          <SimpleCircle
            image={circles.circle_1_image?.url}
            imageAlt={circles.circle_1_image?.alt || "Xometry Image"}
            title={circles.circle_1_title}
            description={circles.circle_1_description}
          />
          <SimpleCircle
            image={circles.circle_2_image?.url}
            imageAlt={circles.circle_2_image?.alt || "Xometry Image"}
            title={circles.circle_2_title}
            description={circles.circle_2_description}
          />
          <SimpleCircle
            image={circles.circle_3_image?.url}
            imageAlt={circles.circle_3_image?.alt || "Xometry Image"}
            title={circles.circle_3_title}
            description={circles.circle_3_description}
          />
        </Circles>
      </div>
    </section>
  ) : (
    <></>
  );
};

export default ThreeSimplecircles;
